const TOTALSHIP_CARRIER_MAP: Record<string, string> = {
  Purolator: 'purolator',
  Dhl: 'dhl',
  DayRoss: 'dayross',
  Fastfrate: 'fastfrate',
  MaritimeOntario: 'maritimeontario',
  Truxweb: 'truxweb',
  Tsl: 'tsl',
  Gls: 'gls',
  Canpar: 'canpar',
  UnishippersAbfFreight: 'abffreight',
  UnishippersXpoLogistics: 'xpologistics',
  UnishippersCentralTransport: 'centraltransport',
  UnishippersEstes: 'estesexpress',
  UnishippersForwardAir: 'forwardair',
  UnishippersFedExFreight: 'fedex',
  UnishippersJpExpress: 'jpexpress',
  UnishippersOldDominion: 'olddominion',
  UnishippersADuiePyle: 'aduiepyle',
  UnishippersRlCarriers: 'rlcarriers',
  UnishippersSaia: 'saia',
  UnishippersTForceFreight: 'tforcefreight',
  UnishippersWardTrucking: 'wardtrucking',
  UnishippersWarp: 'warp',
  EasyPostUps: 'ups',
  EasyPostFedEx: 'fedex',
  UPS: 'ups',
  Ups: 'ups',
  FedEx: 'fedex',
  Fedex: 'fedex',
};

const TOTALSHIP_DISPLAY_MAP: Record<string, string> = {
  Purolator: 'Purolator',
  Dhl: 'DHL',
  DayRoss: 'DayRoss',
  Fastfrate: 'Fastfrate',
  MaritimeOntario: 'MaritimeOntario',
  Truxweb: 'Truxweb',
  Tsl: 'Tsl',
  Gls: 'GLS',
  Canpar: 'Canpar',
  UnishippersAbfFreight: 'ABF Freight',
  UnishippersXpoLogistics: 'XPO Logistics',
  UnishippersCentralTransport: 'Central Transport',
  UnishippersEstes: 'Estes Express',
  UnishippersForwardAir: 'Forward Air',
  UnishippersFedExFreight: 'FedEx Freight',
  UnishippersJpExpress: 'JP Express',
  UnishippersOldDominion: 'Old Dominion',
  UnishippersADuiePyle: 'A. Duie Pyle',
  UnishippersRlCarriers: 'R+L Carriers',
  UnishippersSaia: 'Saia',
  UnishippersTForceFreight: 'TForce Freight',
  UnishippersWardTrucking: 'Ward Trucking',
  UnishippersWarp: 'WARP',
  EasyPostUps: 'UPS',
  EasyPostFedEx: 'FedEx',
  UPS: 'UPS',
  Ups: 'UPS',
  FedEx: 'FedEx',
  Fedex: 'FedEx',
};

// Sorted longest-first to avoid partial matches
const CARRIER_PREFIXES = Object.keys(TOTALSHIP_CARRIER_MAP)
  .sort((a, b) => b.length - a.length);

export function getCarrierLogoCode(carrierCode: string, selectedService: string): string {
  if (carrierCode !== 'TotalShip') return carrierCode.toLowerCase();

  const withoutPrefix = selectedService.replace(/^Ts/, '');
  for (const prefix of CARRIER_PREFIXES) {
    if (withoutPrefix.startsWith(prefix)) {
      return TOTALSHIP_CARRIER_MAP[prefix];
    }
  }
  return 'default';
}

export function getDisplayCarrierCode(carrierCode: string, selectedService: string): string {
  if (carrierCode !== 'TotalShip') return carrierCode;

  const withoutPrefix = selectedService.replace(/^Ts/, '');
  for (const prefix of CARRIER_PREFIXES) {
    if (withoutPrefix.startsWith(prefix)) {
      return TOTALSHIP_DISPLAY_MAP[prefix];
    }
  }
  return carrierCode;
}

export function isTotalShipCarrier(carrierCode: string): boolean {
  return typeof carrierCode === 'string' && carrierCode.toLowerCase() === 'totalship';
}
